import { AppInsightsLogger } from './AppInsightsLogger';
import { LocalLogger } from './LocalLogger';
import { LoggerInterface } from './LoggerInterface';

export const logger: LoggerInterface =
  import.meta.env.MODE === 'development' ? new LocalLogger() : new AppInsightsLogger();
